import { render, staticRenderFns } from "./MyQuotesTable.vue?vue&type=template&id=403285c6&scoped=true&"
import script from "./MyQuotesTable.vue?vue&type=script&lang=js&"
export * from "./MyQuotesTable.vue?vue&type=script&lang=js&"
import style0 from "./MyQuotesTable.vue?vue&type=style&index=0&id=403285c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403285c6",
  null
  
)

export default component.exports